import * as yup from 'yup';

export const FileManagementUploadValidationSchema = yup.object().shape({
    comment: yup.string().nullable().transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
            return originalValue.replace(/(\r\n|\n|\r)/gm, '');
        }
        return value;
    }).max(1000, 'Maximum length is 1000 characters.'),
    file: yup.mixed().test(
        'fileIsRequired',
        'File is required',
        function (item) {
            return (this.parent.file != undefined && this.parent.file.size > 0)
        }
    )
});
